// extracted by mini-css-extract-plugin
export default {"productDescription":"Faa-z","featuredDescription":"Gaa-z","description":"Haa-z","more":"Iaa-z","descriptionSku":"Jaa-z"};